export default __webpack_public_path__ + "static/media/PaintingTheLoft_01.33b6475f.png";